import React from "react";

/**
 * Catches **render-time** errors in child components. Does not catch: top-level import throws,
 * most `useEffect` / async / event-handler throws, or unhandled promise rejections (see AppShell
 * `clientRuntimeError` handler for those).
 */
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("AppErrorBoundary:", error?.message || error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[50vh] flex flex-col items-center justify-center px-6 py-16 text-center bg-orange-50">
          <p className="text-lg font-semibold text-blue-950 mb-2">
            Something went wrong loading this page
          </p>
          <p className="text-sm text-gray-600 max-w-md mb-6">
            Refresh to try again. If this only happens on staging, confirm the latest deployment and
            that staging builds use the correct{" "}
            <code className="text-xs bg-orange-100 px-1 rounded">NEXT_PUBLIC_*</code> env vars (they
            are fixed at build time, not at runtime).
          </p>
          <button
            type="button"
            className="buttonprimary px-6 py-2 rounded-md"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
